import { gql } from "@apollo/client";

export const get_members = gql`
  query Members(
    $where: MemberWhereInput
    $orderBy: [MemberOrderByWithRelationInput!]
    $take: Int
    $skip: Int
    $clinicMembersWhere2: ClinicMemberWhereInput
  ) {
    members(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      name
      phonenumber
      member_id
      status
      note
      image
      medical_history
      aesthetic_history
      created_at
      _count {
        bookings
        checkin
        clinics
        orders
      }
      clinic_members(where: $clinicMembersWhere2) {
        name
      }
    }
  }
`;

export const getMembersVar = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[];
  searchText?: string | null;
  take: number;
  skip?: number;
}) => {
  const { status = [], searchText, take, skip = 0 } = data;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({ name: { contains: searchText } });
    OR.push({ phonenumber: { contains: searchText } });
    OR.push({ member_id: { contains: searchText } });
  }
  where.clinics = { some: { id: { equals: data.clinicId } } };
  //where.created_at = { gte: data.startDate, lte: data.endDate };
  if (status.length > 0) where.status = { in: status };
  if (OR.length > 0) where.OR = OR;
  variables.where = where;
  variables.clinicMembersWhere2 = { clinic_id: { equals: data.clinicId } };
  variables.orderBy = [{ created_at: "desc" }];
  variables.take = take;
  variables.skip = skip;
  return variables;
};

export const get_members_2 = gql`
  query GetMembers(
    $clinicId: String!
    $version: String
    $search: String
    $limit: Int
    $offset: Int
  ) {
    getMembers(
      clinicId: $clinicId
      version: $version
      search: $search
      limit: $limit
      offset: $offset
    ) {
      image
      name
      status
      member_id
      phonenumber
      id
      created_at
    }
  }
`;
export const getMembersVar2 = (data: {
  clinicId: string;
  version: string;
  search: string | null;
  offset: number;
  limit: number;
}) => ({ ...data });

export const get_customer_info = gql`
  query GetCustomerInfo(
    $clinicCode: String!
    $searchName: String
    $searchPhone: String
    $skip: Int
    $take: Int
  ) {
    getCustomerInfo(
      clinicCode: $clinicCode
      searchName: $searchName
      searchPhone: $searchPhone
      skip: $skip
      take: $take
    ) {
      data {
        name
        phoneNumber
        memberId
        totalSpend
        dob
        lastVisited
        lastService
        therapist
        location
        customerTableId
      }
      totalCount
    }
  }
`;

export const getCustomerInfoVar = (data: {
  clinicCode: string;
  searchName?: string | null;
  searchPhone?: string | null;
  skip?: number;
  take?: number;
}) => {
  const variables: any = {
    clinicCode: data.clinicCode,
  };
  if (data.searchName !== undefined && data.searchName !== null) {
    variables.searchName = data.searchName;
  }
  if (data.searchPhone !== undefined && data.searchPhone !== null) {
    variables.searchPhone = data.searchPhone;
  }
  if (data.skip !== undefined) {
    variables.skip = data.skip;
  }
  if (data.take !== undefined) {
    variables.take = data.take;
  }
  return variables;
};

export const get_member_svc_bags = gql`
  query Service_package(
    $where: MemberServiceBagWhereInput
    $orderBy: [MemberServiceBagOrderByWithRelationInput!]
  ) {
    memberServiceBags(where: $where, orderBy: $orderBy) {
      id
      original_count
      remaining_count
      service_id
      service {
        id
        name
      }
      member_id
      service_package_id

      service_package {
        id
        name
      }
      status
    }
  }
`;

export const getMemberSvcBagsVar = (data: {
  clinicId: string;
  memberIds: string[];
}) => {
  let variables: any = {},
    where: any = {};
  where.service = { is: { clinic_id: { equals: data.clinicId } } };
  where.member_id = { in: data.memberIds };
  variables.where = where;
  variables.orderBy = [{ remaining_count: "desc" }];
  return variables;
};
export const get_member_srv_pkgs = gql`
  query MemberServicePackages(
    $where: MemberServicePackageWhereInput
    $orderBy: [MemberServicePackageOrderByWithRelationInput!]
  ) {
    memberServicePackages(where: $where, orderBy: $orderBy) {
      id
      count
      member_id
      status
      service_package_id
      service_package {
        id
        name
      }
    }
  }
`;

export const getMemberSrvPkgsVar = (data: {
  clinicId: string;
  memberIds: string[];
}) => {
  let variables: any = {},
    where: any = {};
  where.service_package = { is: { clinic_id: { equals: data.clinicId } } };
  where.member_id = { in: data.memberIds };
  variables.where = where;
  variables.orderBy = [{ count: "desc" }];
  return variables;
};

export const get_member_bookings = gql`
  query Bookings(
    $where: BookingWhereInput
    $orderBy: [BookingOrderByWithRelationInput!]
  ) {
    bookings(where: $where, orderBy: $orderBy) {
      id
      member_id
      member_note
      practitioner_id
      service_id
      service {
        id
        name
      }
      from_time
      status
    }
  }
`;
export const getMemberBookingVar = (data: {
  clinicId: string;
  memberIds: string[];
  startDate: Date;
  endDate: Date;
}) => {
  let variables: any = {};
  variables.where = {
    clinic_id: { equals: data.clinicId },
    from_time: { gte: data.startDate, lte: data.endDate },
    member_id: { in: data.memberIds },
  };
  variables.orderBy = [{ from_time: "desc" }];
  return variables;
};
export const get_member_checkins = gql`
  query CheckIns(
    $where: CheckInWhereInput
    $orderBy: [CheckInOrderByWithRelationInput!]
  ) {
    checkIns(where: $where, orderBy: $orderBy) {
      id
      in_time
      out_time
      clinic_id
      practitioner_id
      status
      service_id
      service {
        name
        id
      }
      member_id
    }
  }
`;
export const getMemberCheckInVar = (data: {
  clinicId: string;
  memberIds: string[];
  startDate: Date;
  endDate: Date;
}) => {
  let variables: any = {};
  variables.where = {
    clinic_id: { equals: data.clinicId },
    in_time: { gte: data.startDate, lte: data.endDate },
    member_id: { in: data.memberIds },
  };
  variables.orderBy = [{ in_time: "desc" }];
  return variables;
};

export const get_member_detail = gql`
  query Member(
    $where: MemberWhereUniqueInput!
    $bookingsWhere2: BookingWhereInput
    $checkinWhere2: CheckInWhereInput
    $ordersWhere2: OrderWhereInput
    $clinicMembersWhere2: ClinicMemberWhereInput
    $memberServiceBagsWhere2: MemberServiceBagWhereInput
  ) {
    member(where: $where) {
      id
      name
      phonenumber
      member_id
      image
      bookings(where: $bookingsWhere2) {
        member_id
        practitioner_id
        practitioner {
          id
          image
          name
        }
        status
        user_id
        user {
          id
          name
          email
        }
        from_time
        created_at
        to_time
        updated_at
        clinic_id
        service_id
        service {
          id
          image
          name
        }
        member_note
        merchant_note
        service_helper {
          id
          name
        }
      }
      checkin(where: $checkinWhere2) {
        id
        clinic_id
        in_time
        created_at
        out_time
        status
        member_id
        images {
          name
          image
        }
        practitioner_id
        practitioner {
          name
          id
        }
        service_id
        service {
          name
          id
        }
        merchant_note
        booking {
          service_helper {
            id
            name
          }
        }
        metadata
      }
      orders(where: $ordersWhere2) {
        id
        discount
        net_total
        order_id
        status
        total
        clinic_id
        created_at
        payment_method
        tax
        member_id
        member {
          name
          id
        }
        user_id
        user {
          id
          name
        }
        credit_balance
        payment_status
      }
      member_service_bags(where: $memberServiceBagsWhere2) {
        id
        original_count
        remaining_count
        service_id
        service {
          id
          name
        }
        service_package {
          id
          name
        }
      }
      clinic_members(where: $clinicMembersWhere2) {
        image
        id
        member_id
        name
        phonenumber
        note
        metadata
      }
    }
  }
`;

export const getMemberDetailVar = (data: {
  clinicId: string;
  memberId: string;
}) => {
  let variables: any = {},
    clinicFilter = { clinic_id: { equals: data.clinicId } };
  variables.where = { id: data.memberId };
  variables.bookingsWhere2 = clinicFilter;
  variables.checkinWhere2 = clinicFilter;
  variables.clinicMembersWhere2 = clinicFilter;
  variables.memberServiceBagsWhere2 = { service: { is: clinicFilter } };
  variables.ordersWhere2 = {
    ...clinicFilter,
    user: {
      is: {
        role: {
          equals: "ADMIN",
        },
      },
    },
    status: {
      not: {
        equals: "CANCEL",
      },
    },
  };
  return variables;
};

export const create_many_member = gql`
  mutation CreateManyMember(
    $data: [MemberCreateManyInput!]!
    $skipDuplicates: Boolean
  ) {
    createManyMember(data: $data, skipDuplicates: $skipDuplicates) {
      count
    }
  }
`;

export const getCreateManyMemberVar = (
  data: any[],
  skipDuplicates: boolean
) => {
  return { data, skipDuplicates };
};

export const many_member_join_clinic = gql`
  mutation UpdateOneClinic(
    $data: ClinicUpdateInput!
    $where: ClinicWhereUniqueInput!
  ) {
    updateOneClinic(data: $data, where: $where) {
      id
      _count {
        members
      }
    }
  }
`;

export const getManyMemberJoinClinicVar = (
  members: Array<{ phonenumber: string }>,
  clinicId: string
) => {
  let variables: any = {};
  variables.where = { id: clinicId };
  variables.data = {
    members: { connect: members },
  };
  return variables;
};
export const delete_many_member = gql`
  mutation DeleteManyMember($where: MemberWhereInput) {
    deleteManyMember(where: $where) {
      count
    }
  }
`;

export const getDeleteManyMemberVar = (members: string[]) => ({
  where: {
    phonenumber: {
      in: members,
    },
  },
});

export const update_member_bag = gql`
  mutation UpdateOneMemberServiceBag(
    $data: MemberServiceBagUpdateInput!
    $where: MemberServiceBagWhereUniqueInput!
    $createOneSystemLogData2: SystemLogCreateInput!
  ) {
    updateOneMemberServiceBag(data: $data, where: $where) {
      id
    }
    createOneSystemLog(data: $createOneSystemLogData2) {
      id
    }
  }
`;

export const getUpdateMemberBagVar = (data: {
  bagId: string;
  remainCount: number;
  originCount: number;
  log: {
    code: string;
    log_id: string;
    metadata: any;
    user: any;
    log_type: string;
  };
}) => ({
  data: {
    remaining_count: {
      set: data.remainCount,
    },
    original_count: {
      set: data.originCount,
    },
  },
  where: {
    id: data.bagId,
  },
  createOneSystemLogData2: { ...data.log },
});

export const create_member_ecode = gql`
  mutation Ecode($scope: String!, $payload: String!) {
    ecode(scope: $scope, payload: $payload) {
      success
      data
      message
    }
  }
`;

export const createMemberEcodeVar = (args: {
  count: number;
  channel: string;
  refId: string;
  refName: string;
  refBy: string;
  expireAt: string;
  ecode?: string;
}) => {
  let payload: any = {
    expiredAt: args.expireAt,
    count: args.count,
    channel: args.channel,
    refId: args.refId,
    refName: args.refName,
    refBy: args.refBy,
  };
  if (args.ecode) {
    payload["ecode"] = args.ecode;
  }
  return {
    scope: "ecode/create",
    payload: JSON.stringify(payload),
  };
};
